import { SAMPLE_SHIPMENT } from "../constants";
import { instance } from "../../axios";

let getSampleShipment= (id) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE,
    });
    instance({
      method: "GET",
      url: `/sampleshipment/${id}`,
    })
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_FAILURE,
          payload: error,
        });
      });
  };
};

let getSampleShipmentByReference = (reference) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE,
    });
    instance({
      method: "GET",
      url: `/sampleshipment/reference/${encodeURIComponent(reference)}`,
    })
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ONE_FAILURE,
          payload: error,
        });
      });
  };
};


let getSampleShipmentsByStudy = (studyId) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/sampleshipment/study/${studyId}`,
    })
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let createSampleShipment = (body) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE,
    });
    return instance
      .post("/sampleshipment", body)
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE_SUCCESS,
          payload: results.data,
        });
        return results;
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_CREATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let editSampleShipment = (id, body) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE,
    });
    return instance
      .put(`/sampleshipment/${id}`, body)
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE_SUCCESS,
          payload: results.data,
        });
        return results;
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_UPDATE_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let deleteSampleShipment = (id) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_DELETE,
    });
    return instance
      .delete(`/sampleshipment/${id}`)
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_DELETE_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_DELETE_FAILURE,
          payload: error,
        });
      });
  };
};

let getSampleShipmentsByCenter = (centerId) => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL,
    });
    instance({
      method: "GET",
      url: `/sampleshipment/center/${centerId}`,
    })
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

let getSampleShipments = () => {
  return (dispatch) => {
    dispatch({
      type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL,
    });
    instance({
      method: "GET",
      url: "/sampleshipment",
    })
      .then((results) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SAMPLE_SHIPMENT.SAMPLE_SHIPMENT_GET_ALL_FAILURE,
          payload: error,
        });
      });
  };
};

export {
  getSampleShipment,
  getSampleShipmentByReference,
  getSampleShipmentsByStudy,
  createSampleShipment,
  editSampleShipment,
  deleteSampleShipment,
  getSampleShipmentsByCenter,
  getSampleShipments,
};
